export default __webpack_public_path__ + "static/media/logowhite.2df87cfd.svg";